import React, { useEffect, useState } from 'react';
import { related_versions_ticket_path } from 'js-routes/generated/routes';
import { number } from 'prop-types';
import HistoryList from './HistoryList';

const TicketHistory = ({ ticketId = null }) => {
  const [versions, setVersions] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // eslint-disable-next-line react-hooks/set-state-in-effect
    setLoading(true);

    fetch(related_versions_ticket_path(ticketId))
      .then((response) => response.json())
      .then((data) => {
        setVersions(data.versions);
        setLoading(false);
      });
  }, [ticketId]);

  return <HistoryList versions={versions} loading={loading} />;
};

TicketHistory.propTypes = {
  ticketId: number,
};

export default TicketHistory;
